import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Portal from "@/pages/Portal";

/**
 * MyPortal — authenticated client-only view of their portal.
 * Fetches /api/client/portal (auth-gated) and delegates rendering to the
 * shared Portal component by passing a preloaded payload + a signOut handler.
 */
export default function MyPortal() {
  const { user, logout } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (user?.role !== "client") return;
    api.get("/client/portal").then(r => setData(r.data)).catch(e => setErr(e.response?.data?.detail || e.message));
  }, [user]);

  // Loading sentinel — AuthContext uses user===null while /auth/me is in-flight
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-zinc-500 tracking-[0.2em] uppercase text-xs">Loading portal…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "client") return <Navigate to="/" replace />;
  if (err) return <div className="min-h-screen grid place-items-center p-6 text-sm text-rose-600">{err}</div>;
  if (!data) return <div className="min-h-screen grid place-items-center text-zinc-500 tracking-[0.2em] uppercase text-xs">Loading portal…</div>;

  return <Portal preloaded={data} onSignOut={logout} />;
}
